import type { KrossRoom, KrossLinkedRoom } from "../../../../models/integrations/kross.models";
import type { KrossRoomsApiDTO } from "../dtos/kross-rooms.api.dto";

export const mapKrossRoomsDTOToKrossRooms = (dto: KrossRoomsApiDTO): KrossRoom[] => {
  return dto.data.map((room) => ({
    id_property: room.idProperty,
    id_room: room.idRoom,
    id_room_type: room.idRoomType,
    number: room.number,
    name_room_type: room.nameRoomType,
    qt_guests: room.qtGuests,
    max_guest: room.maxGuest,
    address: room.address,
    main_image: room.mainImage,
    active_to: room.activeTo,
  }));
};

// Mapper: Convert Kross API response (snake_case) to internal format (camelCase) for backend
export const mapKrossRoomToInternal = (krossRoom: KrossRoom): KrossLinkedRoom => ({
  idProperty: krossRoom.id_property,
  idRoom: krossRoom.id_room,
  idRoomType: krossRoom.id_room_type,
  number: krossRoom.number,
  nameRoomType: krossRoom.name_room_type,
  qtGuests: krossRoom.qt_guests,
  maxGuest: krossRoom.max_guest,
  address: krossRoom.address,
  mainImage: krossRoom.main_image,
  activeTo: krossRoom.active_to,
});
